import { useSelector } from 'react-redux';

import { getIsReOpsUser } from 'entities/User';
import { useFeatureFlag } from 'shared/lib/hooks/useFeatureFlag';

/**
 * In-order savings (order-level and item-level) is shown only when:
 * - Flipt flag `in_order_savings_enabled` is true, OR
 * - User has a RE-OPS email (@re-ops.co), matching unselected-suppliers behavior.
 */
export const useInOrderSavingsVisible = (): boolean => {
    const inOrderSavingsEnabled = useFeatureFlag('in_order_savings_enabled');
    const isReOpsUser = useSelector(getIsReOpsUser);
    return inOrderSavingsEnabled === true || isReOpsUser;
};
